/* template */
<template minapp="mpx" xlang="wxml"><es-layout :leftArrow="(true)" navbarTitle="本人行程" custom-class="custom-class" @scrolltobottom="onScrollToBottom" :navbarClickLeft="(goBack)" :navbarStyle="(navbarStyle)"><div class="order-tip" v-if="(isShowEmpty)"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/8jPyrnQfol1642402065727.png" class="null-image"/><div class="null-title">暂无火车票行程</div><div class="null-context">当前暂无火车票行程记录</div></div><div class="order-list" v-else><mpx-view v-for="(item, index) in (tickets12306List)" @tap="goDetail(index)" class="item"><newTrainOrderCard :item="(item)" :tickets12306="(true)"/></mpx-view><div class="order-loading">{{ loadingText }}</div></div></es-layout></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mf319ca58"}'>
  .custom-class
    height 100%
  .order-tip
    text-align center
    font-weight 400
    height 100%
    background #F3F4F5
  .null-image
    height 100px
    width 100px
    margin-top 172px
  .null-title
    color #333
    font-size 14px
    margin 16px 0 2px 0
    height 20px
    ling-height 20px
  .null-context
    color #999
    font-size 12px
  .order-list
    padding 2px 10px
  .item
    margin-top 8px
  .order-loading
    height 40px
    width 100%
    text-align center
    line-height 40px
    font-size 14px
    color #666
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf319ca58"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./order-list.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./order-list.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mf319ca58"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'newTrainOrderCard':getComponent(require("../order-list/components/newTrainOrderCard.mpx?isComponent&outputPath=components%2FnewTrainOrderCardb25b7030%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
